import React from 'react';
import classNames from 'classnames';

import css from './BrowseTileNav.module.css';

/**
 * BrowseTileNav provides the shared PageHop browse-tile layout for linked discovery controls.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children browse links or controls
 * @param {string?} props.className additional root class name
 * @param {string} props.ariaLabel navigation landmark label
 * @returns {JSX.Element} horizontally scrollable browse navigation
 */
const BrowseTileNav = ({ children, className, ariaLabel }) => {
  const tiles = React.Children.map(children, child => {
    if (!React.isValidElement(child) || !child.props.active) {
      return child;
    }

    return React.cloneElement(child, {
      className: classNames(child.props.className, css.activeTile),
    });
  });

  return (
    <nav className={classNames(css.root, className)} aria-label={ariaLabel}>
      {tiles}
    </nav>
  );
};

export default BrowseTileNav;
